import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import 'dayjs/locale/th';

const locale = 'th-TH';
const formatOptions = {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
};

/**
 * @param {Date} date - date to format
 * @returns {string} formatted date in Thai
 */
export const formatToThaiDate = (date) => {
  return date.toLocaleDateString(locale, formatOptions);
};

export const getStartAndEndDateOfCurrentWeek = () => {
  /* since require to start the week from Monday, set locale to French
    French locale has Monday as the first day of the week */
  const today = dayjs().locale('fr');

  // set locale to Thai as local time for format the date to Thai format
  const startDateOfThisWeek = today.startOf('week').locale('th').toDate();
  const endDateOfThisWeek = today.endOf('week').locale('th').toDate();

  return {
    startDate: startDateOfThisWeek,
    endDate: endDateOfThisWeek,
  };
};

export const getCurrentWeekRange = () => {
  const { startDate, endDate } = getStartAndEndDateOfCurrentWeek();
  const formatDate = (date) => {
    return dayjs(date).locale('th').format('D MMM');
  };

  return `${formatDate(startDate)} - ${formatDate(endDate)}`;
};

export const canRedirectToTungKai = ({ enable, enableWhiteList, whitelist, userId }) => {
  if (!enable) return false;
  if (!enableWhiteList) return true;

  return Array.isArray(whitelist) && whitelist.includes(userId);
};
